import { ItemTaxonomyId } from "lib/taxonomy/item-taxonomy-id";

import { IOrdersService } from "./i-orders-service";
import { ITOOrdersService } from "./ito-orders-service";

export class OrdersServiceFactory {
  public static getInstance(itemTx: string): IOrdersService {
    const taxonomyId = ItemTaxonomyId.Parse(itemTx);
    const domain: string = taxonomyId.dataDomain ?? "";

    switch (domain) {
      case "amznham":
        return new ITOOrdersService("amznham");
      case "software":
      default:
        return new ITOOrdersService("itmp");
    }
  }
}
